// Delete Code Bulk
export const DELETE_CODE_BULK_REQUEST = 'DELETE_CODE_BULK_REQUEST';
export const DELETE_CODE_BULK_DONE = 'DELETE_CODE_BULK_DONE';
export const DELETE_CODE_BULK_FAILED = 'DELETE_CODE_BULK_FAILED';
